export var SYMBOL = /*#__PURE__*/function (SYMBOL) {
  SYMBOL["ARROW_RIGHT"] = "rightArrow";
  SYMBOL["ARROW_LEFT"] = "leftArrow";
  SYMBOL["ARROW_DOUBLE"] = "doubleArrow";
  return SYMBOL;
}({});
export var PUNC = /*#__PURE__*/function (PUNC) {
  PUNC["DASH"] = "emDash";
  PUNC["ELLIPSIS"] = "ellipsis";
  PUNC["QUOTE_SINGLE"] = "singleQuote";
  PUNC["QUOTE_DOUBLE"] = "doubleQuote";
  return PUNC;
}({});